import { render } from "./Construct.vue?vue&type=template&id=949b98da"
import script from "./Construct.vue?vue&type=script&lang=js"
export * from "./Construct.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/buildings/Construct.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "949b98da"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('949b98da', __exports__)) {
    api.reload('949b98da', __exports__)
  }
  
  module.hot.accept("./Construct.vue?vue&type=template&id=949b98da", () => {
    api.rerender('949b98da', render)
  })

}


export default __exports__